<script setup lang="ts">
import { callWithNuxt } from 'nuxt/app';
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { ReserveType } from '@utils/itinerary';

const contentStore = useContentStore();
const { landingCityName } = classToRefs(contentStore);
const busForm = useBusForm();
const { setReserveType } = useSearchFormStore();
const route = useRoute();
const destination = (route.params.code ?? '') as string;
onServerPrefetch(async () => {
    const app = useNuxtApp();
    if (/\d+/.test(destination)) {
        const busCode = await busForm.findMapRoute(destination);
        callWithNuxt(app, async () => {
            if (!busCode) {
                showError({ statusCode: 410 });
            } else {
                await navigateTo(
                    {
                        path: `/buses/${busCode}`,
                        query: route.query,
                    },
                    { redirectCode: 301 }
                );
            }
        });
    } else {
        useCheckLandingContent();
    }
});
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: `https://mrbilit.com${route.path.replace(/\/$/, '')}`,
        },
    ],
});

onMounted(async () => {
    setReserveType(ReserveType.Bus);
    await busForm.loadLandingSearchParams(destination);
});

definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'بلیط اتوبوس', link: '/bus-ticket' },
        { title: 'بلیط اتوبوس $cityName', link: '$routePath' },
    ]),
});
</script>
<template>
    <InformationContainer
        :title="`راهنمای خرید اینترنتی اتوبوس ${landingCityName} از مِستربلیط`"
    />
</template>
